import axios from "axios";

const httpRequestScoring = axios.create({
  baseURL: process.env.REACT_APP_API_LAPANGBOLA_URL,
  timeout: 30000,
  headers: { "User-Agent": navigator.userAgent + " ByU/1.0" },
});

const getBearerToken = () => {
  const bearerToken = localStorage.getItem("user-data-scoring");

  console.log(bearerToken);

  // temporary
  // return bearerToken?.state?.id_token;
  return bearerToken;
};
console.log("user agent", navigator.userAgent + " ByU/1.0");
const requestHandler = async (request) => {
  // request.headers.authorization = getBearerToken();
  request.headers["User-Agent"] = navigator.userAgent + " ByU/1.0";

  return request;
};

const errorHandler = (error) => {
  return Promise.reject({
    statusCode: error.response.status,
    message: JSON.stringify(error.response.data),
  });
};

httpRequestScoring.interceptors.request.use(
  (request) => {
    return requestHandler(request);
  },
  (error) => {
    return errorHandler(error);
  }
);

httpRequestScoring.interceptors.response.use(
  (response) => response,
  (error) => {
    // console.error(error);
    // if (error.response.status === 403) {
    //   localStorage.clear();
    //   window.location.href = "/login";
    // }
    // reject with error if response status is not 403
    return Promise.reject(error);
  }
);

export default httpRequestScoring;
